import React, { Component, Fragment } from 'react';
import Ripple from '../../common/component/Ripple';
import { Button, Icon, Result } from 'antd';
import FontIcon, { SolidIcons } from '../../common/component/FontIcon';
import * as Func from '../../../../helpers/functions';
import DEFINE from '../../../../constants/Define';

let permisionActions = [];

export default class ProductFeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: {},
    };
  }

  componentDidMount() {
    this.setState({ permissions: Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PRODUCT_FEED) })
  }

  render() {
    const { t, groupState } = this.props;
    const { isFetching } = groupState;
    const { permissions } = this.state;
    return (
      <Fragment>
        {permissions && permissions.allowExportFileExcel ? (
          <Result
            icon={<Icon component={() => <FontIcon icon={SolidIcons.faFileExport}></FontIcon>} />}
            title={t('action.export') + ' ' + t('item.productFeed.title')}
            extra={<Button type="primary" onClick={this.onExportProductFeed} loading={isFetching}>{t('action.export')}</Button>}
          />
        ) : (
            <Result
              status="403"
              title="403"
              subTitle={t('item.productFeed.unauthorized')}
            />
          )}

      </Fragment>
    );
  }

  onExportProductFeed = () => {
    this.props.exportProductFeed();
  };

}
